import AbstractOnboardResource from "@/resources/abstract/AbstractOnboardResource";

export default class VehicleResource extends AbstractOnboardResource {
  async getVehicleInformationByPlate({
    proposalId,
    vehiclePlate,
  }: {
    proposalId: string;
    vehiclePlate: string | number;
  }) {
    try {
      const httpResponse = await this.api.get({
        route: `/proposals/${proposalId}/vehicle/${vehiclePlate}`,
      });

      return this.resourceReturnFactory.create<any>({
        object: {
          error: false,
          data: httpResponse?.data?.response,
          responseObject: httpResponse,
        },
      });
    } catch (e) {
      return this.resourceReturnFactory.create<any>({
        object: {
          error: true,
          data: [],
          responseObject: e,
        },
      });
    }
  }
}
